import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CustomButton from "../components/CustomButton";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AddNewInitiative from "../components/modals/AddNewInitiative";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { InitiativeContext } from "../contexts/InitiativeContextProvider";
import img from "../assets/emptybox.png";
import InitiativeCardSkeleton from "../components/skeleton/InitiativeCardSkeleton";
import ProjectSettingsForm from "../components/forms/ProjectSettingsForm";
import Tasks from "./Tasks";
import { RAGStatus } from "../components/Status";
import styles from "./Project.module.css";
import BreadCrumb from "../components/BreadCrumb";
import Tabs from "../components/ui/Tabs";
import OverviewCard from "../components/ui/OverviewCard";
import DonutChart from "../components/ui/DonutChart";
import FileUpload from "../components/FileUpload";
import ActivityLog from "../components/ActivityLog";
import CustomCard from "../components/ui/CustomCard";
import { LuFolderCheck } from "react-icons/lu";
import { Container } from "react-bootstrap";
import { deleteInitiative, deletePaper } from "../api/Api";
import { FaRegThumbsUp, FaRegThumbsDown } from "react-icons/fa";
// for the donut chart
import { RiWallet3Fill } from "react-icons/ri";
import { FaCircle } from "react-icons/fa6";
import AddLinks from "../components/AddLinks";
import { IoIosArrowDown, IoMdAddCircle } from "react-icons/io";
import { CgNotes } from "react-icons/cg";
import NoticeCard from "../components/ui/NoticeCard";
import { deleteProjectNote, getProjectNotes } from "../api/Api";
import AddNote from "../components/modals/AddNote";
import Box from "../components/ui/Box";
import GeneralProjectInfoCard from "../components/ui/GeneralInfoCard";
import { showToast } from "../utils/toastUtils";
import DeleteModel from "../components/modals/DeleteModel";
import PaperList from "../components/cards/PaperList";
import { Header } from "./Home";
import { NoteIcon } from "../components/Icons/common";
import Warnings from "../components/Warnings";
import NoticeTag from "../components/ui/tags/NoticeTag";
import { VoteButton } from "../components/buttons/VoteButton";
import UpdateWorksreamModal from "../components/modals/UpdateWorkstream";
import { HiOutlineDotsHorizontal, HiOutlineDotsVertical } from "react-icons/hi";
import UpdateBudgetModal from "../components/modals/UpdateBudgetModal";
import { CiEdit } from "react-icons/ci";
import CustomSelectBox from "../components/Inputs/CustomSelectBox";
import Linkify from "react-linkify";
import CustomNotice from "../components/ui/CustomNotice";
import AddNewMember from "../components/modals/AddNewMember";


function Project() {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [showAddInitiative, setShowAddInitiative] = useState(false);
  const [tab, setTab] = useState("overview");
  const [currentProjectId, setCurrentProjectId] = useState(projectId);
  const {
    data: project,
    error,
    loading,
    refresh,
    fetchPapers,
    papers,
    pagination,
    setPagination,
    paperStatusFilter,
    setPaperStatusFilter,
  } = useContext(InitiativeContext);
  const closeAddInitiativeModel = () => setShowAddInitiative(false);
  const handleOpenAddInitiativeModel = () => setShowAddInitiative(true);
  // for the notes
  const [showAddNotePopup, setShowAddNotePopup] = useState(false);
  const [notices, setNotices] = useState([]);
  const [notice, setNotice] = useState({});
  const [isEditNote, setIsEditNote] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [deleteModelPaperId, setDeleteModelPaperId] = useState(null);
  const closeAlert = () => setOpen(false);
  const openAlert = () => setOpen(true);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedInitiative, setSelectedInitiative] = useState(null);
  const location = useLocation();
  const [showMemberNotice, setShowMemberNotice] = useState(true);
  const [showInviteModal, setShowInviteModal] = useState(false);
  console.log(papers);
  
  // -------------------------------------------------
  // fetch project notes
  const fetchProjectNotes = () => {
    getProjectNotes(projectId)
      .then((response) => {
        setNotices(response.data);
      })
      .catch((error) => {
        console.error("Error fetching project notes:", error);
      });
  };

  // view the note (for editing)
  const handleViewNote = (notice) => {
    setNotice(notice);
    setIsEditNote(true); // Set to true for editing
    setShowAddNotePopup(true);
  };

  // add new note
  const handleAddNote = () => {
    setNotice({}); // Clear any existing note data
    setIsEditNote(false); // Set to false for adding new note
    setShowAddNotePopup(true);
  };

  // delete the note
  const handleDeleteNote = (id) => {
    deleteProjectNote(projectId, id)
      .then((response) => {
        if (response.status === 200) {
          fetchProjectNotes();
          showToast("Note deleted successfully.", "success");
        }
      })
      .catch((error) => {
        console.error("Error deleting project note:", error);
      });
  };
  // -------------------------------------------------

  useEffect(() => {
    if (projectId !== currentProjectId) {
      setTab("overview");
      setCurrentProjectId(projectId);
    }
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");
    if (
      tabParam &&
      ["overview", "workStreams", "papers", "goals", "settings"].includes(
        tabParam
      )
    ) {
      setTab(tabParam);
    }

    fetchProjectNotes(projectId);
  }, [projectId, currentProjectId, location.search]);

  if (error) {
    return <div>{error}</div>;
  }

  const limitDescription = (description, charLimit = 200) => {
    if (description.length > charLimit) {
      return description.slice(0, charLimit) + "...";
    }
    return description;
  };

  // array for bread crumb
  const array = [{ title: project?.name, path: `/project/${projectId}` }];
  //function to format date
  const formatDate = (date) => {
    if (!date) return "";
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, "0");
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const year = newDate.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // card data for project overview
  const cardData = {
    id: project?.id,
    name: project?.name,
    description: project?.description,
    owner: project?.owner?.first_name + " " + project?.owner?.last_name,
    startDate: formatDate(project?.start_date),
    endDate: formatDate(project?.end_date),
    memberCount: project?.members.length,
    paperCount: project?.paper_count,
    // totalBudget: project?.total_budget || 12000,
    workStreamCount: project?.initiatives.length || 0,
    status: project?.status, // Add current status
    isProject: true,
  };

  const isWorkStreamEmpty = project?.initiatives.length === 0;

  const handleDeleteInitiative = (id) => {
    deleteInitiative(id)
      .then((response) => {
        if (response.status === 200) {
          showToast("Workstream deleted successfully.", "success");
          refresh();
        }
      })
      .catch((error) => {
        console.error("Error deleting initiative:", error);
        showToast("Failed to delete initiative", "error");
      });
  };

  const handleEditInitiative = (initiative) => {
    setSelectedInitiative(initiative);
    setShowUpdateModal(true);
  };

  const handleCloseUpdateModal = () => {
    setShowUpdateModal(false);
    setSelectedInitiative(null);
  };

  const handleDeletePaper = (paperId) => {
    console.log(paperId);
    deletePaper(paperId)
      .then((response) => {
        if (response?.status === 200) fetchPapers();
        else showToast(response.message, "error");
      })
      .catch((error) => {
        showToast(
          error.response?.data?.message || "Error loading data",
          "error"
        );
      });
    closeAlert();
  };

  const handleMenuItemClick = async (item, value) => {
    // for paper FadeMenu
    if (item === "Delete") setDeleteModelPaperId(value);
    setModalType("Paper");

    openAlert();
  };

  console.log(isEditNote);

  const isPaperEmpty = project?.papers?.length === 0;

  return (
    <section id="projects" className="d-flex gap-3 p-3 h-100">
      <div
        className={`rounded-4 overflow-hidden bg-white w-100 d-flex flex-column`}
      >
        {/* project title */}
        <BreadCrumb array={array} />

        {/* tab for navigation */}
        <Tabs
          tabContentList={[
            "overview",
            "workStreams",
            "papers",
            "goals",
            "settings",
          ]}
          setTab={setTab}
          tab={tab}
        />

        {/* Show member notice if only one member */}
        {tab === "overview" && project?.members?.length === 1 && showMemberNotice && (
          <>
          <CustomNotice
            message={
              "You are the only member of this project.\nStart inviting your team members now."
            }
            onInvite={() => {
              setShowInviteModal(true);
            }}
            onClose={() => setShowMemberNotice(false)}
          />
          <AddNewMember
            show={showInviteModal}
            handleClose={() => setShowInviteModal(false)}
            project_id={projectId}
          />
          </> 
        )}

        <>
          {/* overview tab */}
          {tab === "overview" && (
            <Box>
              <OverviewCard
                cardData={{
                  ...cardData,
                  description: (
                    <span style={{ whiteSpace: "pre-line" }}>
                      {/*spaces and line breaks are preserved*/}
                      <Linkify>{cardData.description}</Linkify>{" "}
                      {/* urls are clikable */}
                    </span>
                  ),
                }}
              />
              <div className="d-flex flex-wrap gap-4 mt-4">
                <div style={{ flex: "1 1 0" }}>
                  <GeneralProjectInfoCard cardData={cardData} />
                </div>
                <div className="flex-grow-1">
                  <ProjectBudget
                    spent={Math.round(project?.balance)}
                    remaining={project?.budget - project?.balance}
                    project={project}
                    refresh={refresh}
                    className="h-100 d-flex flex-column justify-content-between "
                  />
                </div>
              </div>
              <AddLinks entityId={projectId} entityType="project" />
              {/*<FileUpload entityId={projectId} entityType="project" />*/}
              <ActivityLog
                title={"Activity Log"}
                type="project"
                id={projectId}
              />
              {/* <Warnings /> */}
            </Box>
          )}

          {/* work stream tab */}
          {tab === "workStreams" && (
            <Box innerClass="primary-box ">
              <Header
                title="Workstreams"
                buttonTitle="NEW WORKSTREAM"
                buttonIcon={<AddRoundedIcon />}
                onButtonClick={handleOpenAddInitiativeModel}
              />

              {isWorkStreamEmpty ? (
                <div className="w-100 h-75 d-flex flex-column align-items-center justify-content-center gap-3 pt-5">
                  <p className="text-center fst-italic p4 mb-0">
                    Currently, there are no workstream to display.
                    <br /> You can add a new workstream by clicking on the 'New
                    Workstream' button above.
                  </p>

                  <img
                    src={img}
                    className="opacity-25"
                    alt=""
                    style={{ width: "150px" }}
                  />
                </div>
              ) : (
                ""
              )}
              <Row xd={3} lg={3} sm={1} className="m-3  mt-4 w-100 ">
                {loading ? (
                  <InitiativeCardSkeleton n={4} />
                ) : (
                  project?.initiatives?.map((initiative, index) => (
                    <Col key={index} className="mb-3 ">
                      <CustomCard
                        title={initiative.name}
                        description={limitDescription(initiative.description)}
                        icon={<LuFolderCheck size={20} />}
                        onButtonClick={() =>
                          navigate(
                            `/project/${projectId}/initiative/${initiative.id}/?name=${project?.name}`
                          )
                        }
                        onDelete={() => handleDeleteInitiative(initiative.id)}
                        onEdit={() => handleEditInitiative(initiative)}
                      />
                    </Col>
                  ))
                )}
              </Row>
              <UpdateWorksreamModal
                show={showUpdateModal}
                handleClose={handleCloseUpdateModal}
                initiative={selectedInitiative}
                refresh={refresh}
              />
            </Box>
          )}

          {/* papers tab */}
          {tab === "papers" && (
            <Box className="flex-grow-1" innerClass="primary-box h-100">
              <Header
                title="Project Papers"
                icon={<NoteIcon size={35} />}
                buttonTitle="Upload and Validate"
                buttonIcon={<AddRoundedIcon />}
                onButtonClick={() =>
                  navigate(`/manuscript-validator?projectId=${projectId}`)
                }
              />
              <div className="h-100">
                {!isPaperEmpty && (
                  <>
                    <div className="d-flex justify-content-start m-4">
                      <CustomSelectBox
                        value={paperStatusFilter}
                        onChange={(e) => setPaperStatusFilter(e.target.value)}
                        options={[
                          { value: "all", label: "All Status" },
                          { value: "Draft", label: "Draft" },
                          {
                            value: "Ready for Submission",
                            label: "Ready for Submission",
                          },
                          {
                            value: "Submitted to Journal",
                            label: "Submitted to Journal",
                          },
                          {
                            value: "Under Peer Review",
                            label: "Under Peer Review",
                          },
                          {
                            value: "Accepted for Publication",
                            label: "Accepted for Publication",
                          },
                          { value: "Published", label: "Published" },
                          { value: "Rejected", label: "Rejected" },
                        ]}
                      />
                    </div>
                    <PaperList
                      papers={papers}
                      handleMenuItemClick={handleMenuItemClick}
                      projectId={projectId}
                      pagination={pagination}
                      setPagination={setPagination}
                    />
                  </>
                )}

                {isPaperEmpty ? (
                  <div className="w-100 h-75 d-flex flex-column align-items-center justify-content-center gap-3">
                    <p className="text-center fst-italic p4 mb-0">
                      No project papers available.
                      <br /> You can add a new paper by clicking on the 'Upload
                      and Validate' button above.
                    </p>

                    <img
                      src={img}
                      className="opacity-25"
                      alt=""
                      style={{ width: "150px" }}
                    />
                  </div>
                ) : null}
                <DeleteModel
                  open={open && modalType === "Paper"}
                  closeAlert={closeAlert}
                  onClick={() => handleDeletePaper(deleteModelPaperId)}
                  type={modalType}
                />
              </div>
            </Box>
          )}

          {/* settings tab */}
          {tab === "settings" && (
            <>
              <ProjectSettingsForm
                loading={loading}
                project={project}
                projectId={projectId}
                refreshInitiative={refresh}
              />
            </>
          )}

          {/* goals tab */}
          {tab === "goals" && (
            <Tasks
              loading={loading}
              project={project}
              projectId={projectId}
              refreshInitiative={refresh}
            />
          )}
        </>

        {/* add work stream popup */}
        <AddNewInitiative
          show={showAddInitiative}
          handleClose={closeAddInitiativeModel}
          project_id={projectId}
        />
      </div>

      {/* project notes */}
      {tab === "overview" && (
        <div
          style={{ maxWidth: "360px", minWidth: "300px" }}
          className="d-none d-xl-block rounded-4 overflow-hidden"
        >
          <div className="d-flex justify-content-between align-items-center p-4 bg-body-secondary">
            <div className="d-flex align-items-center gap-2">
              <div className="rounded-2 border border-2 border-secondary-subtle">
                <IoIosArrowDown size={23} />
              </div>
              <CgNotes size={23} />
              <p className="p3 fw-medium text-center m-0">Project Notes</p>
            </div>
            <IoMdAddCircle
              size={24}
              style={{ cursor: "pointer" }}
              onClick={handleAddNote} // Now properly handles adding new note
            />
          </div>
          <div className="d-flex flex-column gap-3 bg-white p-4">
            {notices?.map((notice, index) => (
              <NoticeCard
                key={index}
                notice={notice}
                onClick={() => handleViewNote(notice)}
                onDelete={() => handleDeleteNote(notice.id)}
              />
            ))}
            {notices?.length === 0 && (
              <div className="d-flex flex-column align-items-center justify-content-center gap-3 h-100">
                <p className="text-center text-color-tertiary fst-italic fs-6 mb-0">
                  No notes available.
                  <br /> You can add a new note by clicking on the '+' button
                  above.
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* add note popup */}
      <AddNote
        show={showAddNotePopup}
        project_id={projectId}
        entity_type="project"
        refresh={fetchProjectNotes}
        handleClose={() => {
          setShowAddNotePopup(false);
          setNotice({});
        }}
        isEdit={isEditNote}
        setIsEdit={setIsEditNote}
        note={notice}
      />
    </section>
  );
}

export default Project;

export const ProjectBudget = ({
  project,
  nonAllocated = 0,
  remaining = 0,
  spent = 0,
  className,
  refresh,
}) => {
  const [showModal, setShowModal] = useState(false);
  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <>
      <div
        className={`${styles.budgetContainer} rounded-4 bg-white p-4 m-1 ${className}`}
      >
        {/*<div className="d-flex justify-content-end">
        <NoticeTag title="Coming Soon"/>
      </div>*/}
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex align-items-center gap-3">
            <RiWallet3Fill size={27} className={styles.walletIcon} />
            <h4>Project Budget</h4>
          </div>
          <button
            className="btn btn-link p-0 m-0 text-dark"
            style={{ fontSize: "1.5rem", lineHeight: "1", marginTop: "5px" }}
            onClick={handleOpen}
          >
            <CiEdit color="var(--blue)" />
          </button>
        </div>
        <div className="d-flex justify-content-center">
          <DonutChart
            // nonAllocated={nonAllocated}
            remaining={remaining}
            spent={spent}
          />
        </div>

        {/* legends of the chart */}
        <div>
          {/*<Legend
          color="#103649"
          text="Non-Allocated"
          amount={nonAllocated}
          className="justify-content-center"
        /> */}
          <div className="d-flex align-items-center justify-content-center gap-2 ">
            <Legend
              color="#0BD5FE"
              text="Spent"
              amount={spent}
              className="justify-content-end"
            />
            <span className="h6 fw-bold">|</span>
            <Legend color="#FFC942" text="Remaining" amount={remaining} />
          </div>
        </div>

        {/* <div className="d-flex align-items-center mt-2">
        <VoteButton variant="color" />
      </div> */}
      </div>
      <UpdateBudgetModal
        show={showModal}
        handleClose={handleClose}
        project={project}
        refresh={refresh}
      />
    </>
  );
};

const Legend = ({ color, text, amount, className }) => {
  return (
    <div className={`d-flex align-items-center gap-2 ${className}`}>
      <FaCircle size={8} color={color} />
      <div className="p5 text-nowrap">
        {text} : <span className="p5 fw-bold">{amount}</span>
      </div>
    </div>
  );
};
